import React from 'react';
import PropTypes from 'prop-types';

import VstInput from './VstInput';

const Button = ({ children }) => (
  <div className="vst-input-button">
    {children}
  </div>
);
Button.propTypes = {
  children: PropTypes.node.isRequired,
};

const Addon = ({ children }) => (
  <div className="vst-input-addon">
    {children}
  </div>
);
Addon.propTypes = {
  children: PropTypes.node.isRequired,
};

const Input = (props) => (
  <VstInput {...props} ignoreLabel />
);

const VstInputGroup = ({ children, label, height }) => (
  <div className="vst-input-group">
    <fieldset>
      {label && <legend>{label}</legend>}
      <div className="vst-input-row" style={{ height }}>
        {children}
      </div>
    </fieldset>
  </div>
);

VstInputGroup.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  height: PropTypes.string,
};
VstInputGroup.defaultProps = {
  label: null,
  height: '32px'
};

VstInputGroup.Addon = Addon;
VstInputGroup.Button = Button;
VstInputGroup.Input = Input;

export default VstInputGroup;
